import { render, staticRenderFns } from "./CategoryLabel.vue?vue&type=template&id=7984de8a&scoped=true&"
import script from "./CategoryLabel.vue?vue&type=script&lang=js&"
export * from "./CategoryLabel.vue?vue&type=script&lang=js&"
import style0 from "./CategoryLabel.vue?vue&type=style&index=0&id=7984de8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7984de8a",
  null
  
)

export default component.exports